var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTim({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1165 22.9874H2V26.2886H20.1165V22.9874Z",
    fill: "#D30B20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28685 28.6501H2V31.9513H9.28685V28.6501Z",
    fill: "#D30B20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28685 34.2735H2V37.5748H9.28685V34.2735Z",
    fill: "#D30B20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1167 28.6501H12.8298V31.9513H20.1167V28.6501Z",
    fill: "#D30B20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1167 34.2735H12.8298V37.5748H20.1167V34.2735Z",
    fill: "#D30B20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6055 22.9883H35.3074V26.2896H30.8521V37.5755H28.0206V26.2896H23.6055",
    fill: "#1C3E80"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9641 22.988H36.7568V37.5752H39.9641V22.988Z",
    fill: "#1C3E80"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4128 22.975H46.9959L50.7131 31.9393L54.4304 23.0018H58V37.589L55.3564 37.5621V27.3766L52.0417 35.3479H49.3712L46.07 27.2558V37.5621H43.4128V22.975Z",
    fill: "#1C3E80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTim);
export default __webpack_public_path__ + "static/media/tim.5f38bc9ac23bd0e3547e41945cd5aff2.svg";
export { ForwardRef as ReactComponent };